import { Injectable } from '@angular/core';
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { HttpClient } from '@angular/common/http';
import { HttpClientAbstract } from 'src/app/shared/service/http-client-abstract';
import { Observable, of } from 'rxjs';
import {
  NotificationMethod,
  NotificationFilter
} from 'src/app/shared/model/notification.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends HttpClientAbstract {
  // SlackURLテストに成功したか否か
  slackUrlTested: boolean = false;
  // SlackURLがDBに登録済みか否か
  slackUrlRegisterd: boolean = false;

  constructor(header: HttpHeaderService, http: HttpClient) {super(header, http);}

  // new api
  // notificationMethod
  public getNotificationMethods(): Observable<NotificationMethod[]> {
    return super
      .requestGet('api/v1/notification_methods')
      .pipe(map(res => res.body));}

  public createNotificationMethod(
    method: NotificationMethod
  ): Observable<NotificationMethod> {
    return super
      .requestPost('api/v1/notification_methods', {
        notification_method: method
      })
      .pipe(map(res => res.body));}

  public updateNotificationMethod(
    method: NotificationMethod
  ): Observable<NotificationMethod> {
    if (!!!method.id) {
      return this.createNotificationMethod(method);
    }
    return super
      .requestPatch(`api/v1/notification_methods/${method.id}`, {
        notification_method: method
      })
      .pipe(map(res => res.body));}

  public deleteNotificationMethod(
    method: NotificationMethod
  ): Observable<NotificationMethod> {
    return super.requestPatch(`api/v1/notification_methods/${method.id}`, {
      notification_method: method
    });}

  public checkSlackUrlMethod(
    method: NotificationMethod
  ): Observable<NotificationMethod> {
    return super
      .requestPost(`api/v1/notification_methods/slack_validity_test`, {
        notification_method: method
      })
      .pipe(map(res => res.body));}

  // SlackURLテストに成功したか否か、フラグを返す
  public isSlackUrlTested (): boolean {
    return this.slackUrlTested
  }
  // DBにSlackURLが登録されているかどうか
  public isRegisteredSlackUrl (): boolean {
    return this.slackUrlRegisterd
  }

  // notificationFilters
  public getNotificationFilters(): Observable<NotificationFilter[]> {
    return super
      .requestGet('api/v1/notification_filters')
      .pipe(map(res => res.body));}

  public createNotificationFilter(
    filter: NotificationFilter
  ): Observable<NotificationFilter> {
    return super
      .requestPost('api/v1/notification_filters', {
        notification_filter: filter
      })
      .pipe(map(res => res.body));}

  public updateNotificationFilter(
    filter: NotificationFilter
  ): Observable<NotificationFilter> {
    console.log(filter);

    return super
      .requestPatch(`api/v1/notification_filters/${filter.id}`, {
        notification_filter: filter
      })
      .pipe(map(res => res.body));}

  public deleteNotificationFilter(
    filter_id: number
  ): Observable<NotificationFilter> {
    return super
      .requestDelete(`api/v1/notification_filters/${filter_id}`, {
        notification_filter: { id: filter_id }
      })
      .pipe(map(res => res.body));}
}
